
export function scrollTo(ref) {
    setTimeout(() => {
        const y = ref.current.offsetTop - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }, 200);
}